export const WORK_WITH_DATA = [
  {
    title: 'Mc Cann EricKson Italy',
    subTitle: 'Smart working - Welfare organization',
  },

  {
    title: 'Continental Italia',
    subTitle:
      'New italian plant and logistic whorehouse opening - Dismissal social security advisory',
  },

  {
    title: 'Norwegian Airlines Italia',
    subTitle: 'Italian location and related HR management',
  },
  {
    title: 'Tom Ford Italia retail',
    subTitle: 'International assigny – Eu secondment',
  },
  {
    title: 'Bizerba',
    subTitle: 'On site customer care and technical manteinence – MBO agreement',
  },

  {
    title: 'Gruppo Permasteelisa',
    subTitle: 'Due Diligence for stock exchange market quotation',
  },
  {
    title: 'Gruppo Cose Belle d’Italia',
    subTitle: 'Journalist management',
  },

  {
    title: 'Link Gruppo',
    subTitle: 'Company restructuring - Production requalification',
  },
  {
    title: 'Camuzzi Gazometri',
    subTitle: 'Dismissal social security advisory - Sales of business',
  },
  { title: 'Hovione', subTitle: 'Payroll due diligence' },
  {
    title: 'Ineos Sales',
    subTitle: 'Board members legal responsability',
  },
  {
    title: 'Intersystems Italia',
    subTitle: 'Merge and acquisition',
  },
  {
    title: 'Wanhua Borsodchem',
    subTitle: 'Company’s internal rules',
  },
  {
    title: 'Beckton Dickinson Italia',
    subTitle: 'International assigny – Italian secondment',
  },

  {
    title: 'LGC Standards',
    subTitle: 'Company’s internal rules',
  },
  {
    title: 'Arla Foods Italia',
    subTitle: 'Company’s internal rules',
  },
  {
    title: 'AudioCodes Italy',
    subTitle: 'International assigny – Italian secondment',
  },
  {
    title: 'BetClic',
    subTitle: 'International assigny – EU secondment',
  },
  {
    title: 'La Rinascente',
    subTitle: 'International assigny – EU secondment',
  },
  {
    title: 'Bottega Veneta',
    subTitle: 'International assigny – Italian secondment',
  },
  {
    title: 'Nestlè',
    subTitle: 'International assigny – Italian secondment',
  },
  {
    title: 'Reckitt Benckiser Italia',
    subTitle: 'International assigny – Italian secondment',
  },
];
